/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { ArchiveResult, Pagination } from "../../utils/Interfaces";

export interface ArchiveState {
    query: string;
    count: number;
    results: ArchiveResult[];
}

const initialState: ArchiveState = {
    query: "",
    count: 0,
    results: [] as ArchiveResult[],
};

export const archiveSlice = createSlice({
    name: "archive",
    initialState,
    reducers: {
        setArchiveResults: (state, action: PayloadAction<Pagination<ArchiveResult>>) => {
            state.results = action.payload.results;
            state.count = action.payload.count;
        },
        clearArchiveResults: (state) => {
            state.results = [] as ArchiveResult[];
            state.count = 0;
            state.query = "";
        },
        setArchiveQuery: (state, action: PayloadAction<string>) => {
            state.query = action.payload;
        },
    },
});

export const { setArchiveResults, clearArchiveResults, setArchiveQuery } = archiveSlice.actions;

export const selectArchiveResults = (state: RootState) => state.archive.results;
export const selectArchiveResultsCount = (state: RootState) => state.archive.count;
export const selectArchiveQuery = (state: RootState) => state.archive.query;

export default archiveSlice.reducer;
